const FormStatusReducer = (state = false, action) => {
    switch(action.type){
        case "FORM_SUCCESS":
            state =  true;
            break;
        default:
            return state;
    }
    return state;
}

export default FormStatusReducer;